module.exports = __webpack_public_path__ + "img/not-found.7d7b26e2.svg";